import filters from '@/api/filter';
export const config = {
  data() {
    return {
      columns: []
    };
  },
  mounted() {
    this.getColumns();
  },
  methods: {
    getColumns() {
      let columns = [
        {
          title: '保单号',
          slot: 'policyNo',
          align: 'center',
          width: 140
        },
        {
          title: '产品',
          key: 'productName',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            return (
              <span>
                {params.row.productName}({params.row.productCode})
              </span>
            );
          }
        },
        {
          title: '出单业务员',
          key: 'salesmanName',
          minWidth: 100,
          align: 'center'
        }
      ];
      columns.push(
        {
          title: '投被保人',
          key: 'insuranceName',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            const res = params.row.insuranceName ? params.row.holderName + '/' + params.row.insuranceName : params.row.holderName;
            return (
              <Tooltip style="width:100%" content={res}>
                <div class="txt-ellipsis2" style="display:block">
                  {res}
                </div>
              </Tooltip>
            );
          }
        },
        {
          title: '承保日期',
          key: 'insureTime',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            const res = filters.filterTime(params.row.insureTime, 'YYYY-MM-DD');
            return <span>{res}</span>;
          }
        },
        {
          title: '保费(元)',
          key: 'fee',
          width: 120,
          align: 'center'
        },
        {
          title: '质检状态',
          slot: 'qualityStatus',
          minWidth: 120,
          align: 'center'
        },
        {
          title: '出单团队',
          key: 'groupName',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            const res = params.row.groupName ? params.row.orgName + '/' + params.row.groupName : params.row.orgName;
            return (
              <Tooltip style="width:100%" content={res}>
                <div class="txt-ellipsis2" style="display:block">
                  {res}
                </div>
              </Tooltip>
            );
          }
        },
        {
          title: '操作',
          slot: 'action',
          width: 100,
          align: 'center',
          fixed: 'right'
        }
      );
      this.columns = columns;
    }
  }
};
